<template>
    <div class="flex-grow-1">
        <print-labels @print="printStickers" class="d-flex flex-column mb-5"/>
        <b-row>
            <b-col md="8">
                <review-shipping-plan></review-shipping-plan>
            </b-col>
            <b-col md="1" offset="3">
                <b-btn variant="primary-user"
                       size="sm"
                       :disabled="$store.state.loading"
                       :to="{name: 'Step2'}">
                    Continue
                </b-btn>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import PrintLabels from '~cp/UserPanel/Elements/PrintLabels'
    import {getPDF} from 'api/services'
    import ReviewShippingPlan from '~cp/UserPanel/Elements/ReviewShippingPlan'

    export default {
        name: 'Step1',
        components: {
            PrintLabels,
            ReviewShippingPlan
        },
        methods: {
            printStickers(data) {
                getPDF(this.$endpoints.incomePrint(this.$route.params.planId), data).then()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/Replenishment/Shipment/CreateShipment/Step1.vue